import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const { isCognitoLoggedIn, shouldSkipSetupMFA } = useAuth();
    const navigate = useNavigate();
    const storageshouldSkipSetupMFA = window.localStorage.getItem('shouldSkipSetupMFA');
    const tenantSelected = window.localStorage.getItem('tenantSelected') === 'true';
    // Context may be undefined on first paint after navigation from GuestGuard (same tick); treat as logged in if we just selected tenant
    const isLoggedIn = isCognitoLoggedIn === true || (isCognitoLoggedIn === undefined && tenantSelected);

    useEffect(() => {
        if (!shouldSkipSetupMFA && !storageshouldSkipSetupMFA) {
            navigate(`/setupmfa`, { replace: true });
        }
        if (!isLoggedIn) {
            navigate(`/login`, { replace: true });
        }
    }, [isCognitoLoggedIn, isLoggedIn, navigate, shouldSkipSetupMFA, storageshouldSkipSetupMFA, tenantSelected]);

    if (!isLoggedIn) return null;

    return children;
};

export default AuthGuard;
